import { FileModel } from './file-model.model';
import { FolderPathInfo } from './folder-path-info.model';

export class Folder<T = FileModel> {
    id: string;
    name: string;
    files: T[] = [];
    folders: Folder<T>[] = [];
    totalFilesCount: number;
    totalFolderCount: number;
    uri: string;
    rootFolder: boolean;
    folderPath: FolderPathInfo[];
    createdAt?: Date | string;

    constructor(
        id: string,
        name: string,
        files: T[],
        folders: Folder<T>[],
        totalFilesCount: number,
        totalFolderCount: number,
        uri: string,
        rootFolder: boolean,
        folderPath: FolderPathInfo[],
        createdAt?: Date | string,
    ) {
        this.id = id;
        this.name = name;
        this.files = files;
        this.folders = folders;
        this.totalFilesCount = totalFilesCount;
        this.totalFolderCount = totalFolderCount;
        this.uri = uri;
        this.rootFolder = rootFolder;
        this.folderPath = folderPath;
        this.createdAt = createdAt;
    }

    static createFileModelInstance(obj: {
        id: string;
        name: string;
        files: FileModel[];
        folders: Folder<FileModel>[];
        totalFilesCount: number;
        totalFolderCount: number;
        uri: string;
        rootFolder: boolean;
        folderPath: FolderPathInfo[];
        createdAt?: Date | string;
    }): Folder<FileModel> {
        return new Folder<FileModel>(
            obj.id,
            obj.name,
            (obj.files = obj.files?.map(file => {
                return FileModel.createInstance(file);
            })),
            obj.folders?.map(folder => Folder.createFileModelInstance(folder)),
            obj.totalFilesCount,
            obj.totalFolderCount,
            obj.uri,
            obj.rootFolder,
            obj.folderPath,
            obj.createdAt,
        );
    }

    static createFileModelMedInstance(obj: {
        id: string;
        name: string;
        files: FileModel[];
        folders: Folder<FileModel>[];
        totalFilesCount: number;
        totalFolderCount: number;
        uri: string;
        rootFolder: boolean;
        folderPath: FolderPathInfo[];
        createdAt?: Date | string;
    }): Folder<FileModel> {
        return new Folder<FileModel>(
            obj.id,
            obj.name,
            (obj.files = obj.files?.map(file => {
                return FileModel.createInstance(file);
            })),
            obj.folders?.map(folder => Folder.createFileModelMedInstance(folder)),
            obj.totalFilesCount,
            obj.totalFolderCount,
            obj.uri,
            obj.rootFolder,
            obj.folderPath,
            obj.createdAt,
        );
    }
}
